import { render, staticRenderFns } from "./HealthCheck35PsaThyroid.vue?vue&type=template&id=30f71912&scoped=true&"
import script from "./HealthCheck35PsaThyroid.vue?vue&type=script&lang=js&"
export * from "./HealthCheck35PsaThyroid.vue?vue&type=script&lang=js&"
import style0 from "./HealthCheck35PsaThyroid.vue?vue&type=style&index=0&id=30f71912&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f71912",
  null
  
)

export default component.exports